import request from '@/utils/request'

//getResNoList
export function getResNoList(param) {
  let data = param
  return request({
    url: `/deliveryControl/epms90a0/getResNoList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epms90a1Head
export function epms90a1Head(param) {
  let data = param
  return request({
    url: `/deliveryControl/epms90a0/epms90a1Head`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epms90a1Detail
export function epms90a1Detail(param) {
  let data = param
  return request({
    url: `/deliveryControl/epms90a0/epms90a1Detail`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//getShipNoList
export function getShipNoList(param) {
  let data = param
  return request({
    url: `/deliveryControl/epms90a0/getShipNoList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//getPorNoListF
export function getPorNoListF(param) {
  let data = param
  return request({
    url: `/deliveryControl/epms90a0/getPorNoListF`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epms90a0List
export function epms90a0List(param) {
  let data = param
  return request({
    url: `/deliveryControl/epms90a0/epms90a0List`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epms90a2Save
export function epms90a2Save(param) {
  let data = param
  return request({
    url: `/deliveryControl/epms90a0/epms90a2Save`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epms90a2Delete
export function epms90a2Delete(param) {
  let data = param
  return request({
    url: `/deliveryControl/epms90a0/epms90a2Delete`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epms90a0xls
export function epms90a0xls(param) {
  let data = param
  return request({
    url: `/deliveryControl/epms90a0/epms90a0xls`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  }).then(res => {

    const binaryString = window.atob(res.body)
    const binaryLen = binaryString.length
    let bytes = new Uint8Array(binaryLen)
    
    for (let i = 0; i < binaryLen; i++) {
      let ascii = binaryString.charCodeAt(i)
      bytes[i] = ascii
    }
    
    const blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
    const blobURL = URL.createObjectURL(blob)

    const link = document.createElement('a');
    link.href = blobURL;
    link.download = `Raw Material.xls`;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  })
}
